<template>
  <div class="container">
    <p style="text-align: center">
      <span style="font-size: 24px; font-weight: 700">
        《用户协议和法律协议》
      </span>
    </p>
    <p>
      本协议为您与本站管理者之间所订立的契约，具有合同的法律效力，请您仔细阅读。
    </p>
    <p>
      本协议内容包括协议正文及所有本站已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。如您对协议有任何疑问，应向本站咨询。您在同意所有协议条款并完成注册程序，才能成为本站的正式用户，您点击“我以阅读并同意
      本站用户协议和法律协议”按钮后，本协议即生效，对双方产生约束力。
    </p>
    <p>
      只要您使用本站平台服务，则本协议即对您产生约束，届时您不应以未阅读本协议的内容或者未获得本站对您问询的解答等理由，主张本协议无效，或要求撤销本协议。您确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用本站平台服务。本站有权根据需要不定期地制订、修改本协议及/
      或各类规则，并在本站平台公示，不再另行单独通知用户。变更后的协议和规则一经在网站公布，立即生效。如您不同意相关变更，应当立即停止使用本站平台服务。您继续使用本站平台服务的，即表明您接受修订后的协议和规则。
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px"> 注册 </span>
      </strong>
    </p>
    <p>
      <span>
        1.1
        注册资格用户须具有法定的相应权利能力和行为能力的自然人、法人或其他组织，能够独立承担法律责任。您完成注册本站平台同意的方式实际使用本平台服务时，即视为您确认自己具备主体资格，能够独立承担法律责任。若因您不具备主体资格，而导致的一切后果，由您及您的监护人自行承担。
      </span>
    </p>
    <h2>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span style="font-family: 黑体">注册资料</span>
        </span>
      </strong>
    </h2>
    <p>
      <span>
        2.1
        用户应自行诚信向本站提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且本站保留终止用户使用本平台各项服务的权利。
      </span>
    </p>
    <p>
      <span>
        2.2
        用户在本站进行浏览等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。
      </span>
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          <span>账户</span>
        </span>
      </strong>
    </p>
    <p>
      <span>
        3.1
        您注册成功后，即成为本站平台的会员，将持有本站平台唯一编号的账户信息，您可以根据本站规定改变您的密码。
      </span>
    </p>
    <p>
      <span>
        3.2
        您设置的姓名为真实姓名，不得侵犯或涉嫌侵犯他人合法权益。否则，本站有权终止向您提供服务，注销您的账户。账户注销后，相应的会员名将开放给任意用户注册登记使用。
      </span>
    </p>
    <p>
      <span>
        3.3
        您应谨慎合理的保存、使用您的会员名和密码，应对通过您的会员名和密码实施的行为负责。除非有法律规定或司法裁定，且征得本站的同意，否则，会员名和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。
      </span>
    </p>
    <p>
      <span>
        3.4
        用户不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
      </span>
    </p>
    <p>
      <span>
        3.5
        如果发现任何非法使用等可能危及您的账户安全的情形时，您应当立即以有效方式通知本站要求暂停相关服务，并向公安机关报案。您理解本站对您的请求采取行动需要合理时间，本站对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。
      </span>
    </p>
    <p>
      <span>
        3.6
        用户同意在用户有下列情况下，本公司可以删除用户注册的账号，终止向用户提供产品和服务：
      </span>
    </p>
    <p style="margin-left: 70px">
      <span>a)&nbsp;</span>
      违反本合约的规定。
    </p>
    <p style="margin-left: 70px">
      <span>b)&nbsp;</span>
      提供虚假注册信息。
    </p>
    <p style="margin-left: 70px">
      <span>c)&nbsp;</span>
      有严重损害其他用户的行为。
    </p>
    <p style="margin-left: 70px">
      <span>d)&nbsp;</span>
      有违反法律、法规的行为或言论。
    </p>
    <p style="margin-left: 70px">
      <span>e)&nbsp;</span>
      有违背社会风俗、社会道德和互联网一般道德和礼仪的行为。
    </p>
    <p style="text-indent: 42px">
      因上述原因删除用户注册的账号后即不再对用户承担任何义务和责任。
    </p>
    <p>
      <strong>
        <span style="font-family: 黑体; font-size: 18px">
          用户信息的合理使用
        </span>
      </strong>
    </p>
    <p>
      <span>
        4.1
        您同意本站拥有通过邮件、短信电话等形式，向在本站注册用户发送信息等告知信息的权利。
      </span>
    </p>
    <p>
      <span>
        4.2
        您了解并同意，本站有权应国家司法、行政等主管部门的要求，向其提供您在本站填写的注册信息和交易记录等必要信息。如您涉嫌侵犯他人知识产权，则本站亦有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供您必要的身份信息。
      </span>
    </p>
    <p>
      <span>
        4.3
        用户同意本站有权使用用户的注册信息、用户名、密码等信息，登陆进入用户的注册账户，进行证据保全。
      </span>
    </p>
    <br />
  </div>
</template>

<script>
export default {
  name: "ros-privacy-policy",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.container {
  margin: 20px auto;
  text-align: initial;
  max-width: 1200px;
  font-family: 宋体;
  font-size: 14px;
  height: auto;
}
p {
  line-height: 24px;
}
@media (max-width: 768px) {
  .container {
    font-size: 12px !important;
    color: #555;
    padding: 0 5%;
    width: 90%;
    background: rgb(14, 80, 177);
    .container {
      background-color: #fff;
      border-radius: 10px;
      padding-top: 20px;
    }
    .wrapper {
      .container {
        background: none;
      }
    }
  }
}
</style>
